var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Checkbox',{attrs:{"dense":"","required":"","label":"Ja, jeg giver Lasso X lov til at kontakte mig angående Lassos løsning og behovet for erhvervsoplysninger og markedsdata.","modelValue":_vm.value,"errorText":_vm.errorText},on:{"change":value => _vm.$emit('change', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }